export default __webpack_public_path__ + "c7e602330fccb3165f8b6c549aafb608.svg";